import {
  PENDING,
  FULFILLED,
  REJECTED,
} from 'app/providers/StoreProvider/middleware/dynamicCrumbs/constants';
import { breadcrumbsActions } from 'shared/store/breadcrumbs';

import type { TitleGetterParameters, TypeHandlersMapArgs } from './types';

const { addDynamicCrumb, addDynamicCrumbFulfilled, addDynamicCrumbRejected } =
  breadcrumbsActions;

export const typeHandlersMap = <T extends TitleGetterParameters>({
  breadcrumb,
  dispatch,
  pathname,
  titleGetter,
  payload,
}: TypeHandlersMapArgs<T>) => {
  const handlePending = () => {
    if (breadcrumb) return;

    dispatch(addDynamicCrumb({ pathname }));
  };
  const handleFulFilled = () => {
    if (!breadcrumb) return;

    dispatch(
      addDynamicCrumbFulfilled({
        pathname,
        title: titleGetter(payload),
      }),
    );
  };

  const handleRejected = () => {
    if (!breadcrumb) return;

    dispatch(addDynamicCrumbRejected({ pathname }));
  };

  return {
    [PENDING]: handlePending,
    [FULFILLED]: handleFulFilled,
    [REJECTED]: handleRejected,
  };
};
